<template>
    <input type="email" ref="usermail" :disabled="validateMailConditions()" :value="modelEmail" v-on:input="$emit('input', $event.target.value)" name="email" @focus="activeField = true" :class="{'invalid': validEmail === false && !activeField}" @blur="validateEmail(value)" />
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'email-validation',
    props: [
        'value',
        'autofocus',
        'newUser'
    ],
    data () {
        return {
            validEmail: null,
            activeField: false,
            modelEmail: this.value
        }
    },
    watch: {
        value (modelEmail) {
            this.modelEmail = modelEmail
        }
    },
    computed: {
        ...mapGetters({
            user: 'getEmployee'
        })
    },
    methods: {
        validateMailConditions () {
            if (this.modelEmail && !this.newUser) {
                return true
            } else {
                return false
            }
        },
        validateEmail (email) {
            this.activeField = false

            if (email) {
                let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (regex.test(email)) {
                    this.validEmail = true
                } else {
                    this.validEmail = false
                    this.$notify({group: 'info', type: 'warn', title: '', text: 'E-mailen er ikke udfyldt korrekt. Prøv venligst igen.'})
                }
            } else {
                this.validEmail = null
            }

            this.$emit('validateEmail', this.validEmail)
        }
    },
    mounted () {
        if (this.autofocus) {
            this.$nextTick(() => this.$refs.usermail.focus())
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/email/email-validation.vue